import React from "react";
import "./profile.css";

export default function ConfirmModal({ label, deleteUser, cancelRequest, id, btnLabel, selectedService, setSelectedService, showMediumOption }) {
  return (
    <div className="confirm-delete-wrapper register-medium">
      <div data-backdrop="static" className="modal fade" id={id} role="dialog">
        <div className="modal-dialog modal-dialog-preview">
          <div className="modal-content">
            <div className="modal-body">
              <div className="icon-pop">
                <img src="/images/Union-icon.png" alt="Union-icon" />
              </div>

              <select
                name="selectservice"
                className="select-boxpractive-book"
                value={selectedService}
                onChange={(e) => setSelectedService(e.target.value)}
              >
                <option disabled value="">Select One</option>
                <option value="1-on-1 Coaching">1-on-1 Coaching</option>
                <option value="Group Coaching">Group Coaching</option>
                {showMediumOption && (
                  <option value="Mediumship Session">Mediumship Session</option>
                )}
              </select>
              <div className="confirm-btn-box">
                <div
                  className="register-medium-confirnation"
                  onClick={cancelRequest}
                  data-dismiss="modal"
                >
                  Cancel
                </div>
                <div
                  className="register-medium-confirnation"
                  data-dismiss="modal"
                  onClick={() => deleteUser(id)}
                >
                  {btnLabel}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
